import React, { useMemo } from "react";
import "./BookingCard.css";
import { useAgent } from "contexts/v1/masterData/AgentContext";
import { useLabel } from "contexts/v1/masterData/LabelContext";
import { getContrastColor } from "utils/utils";

const STATUS_COLORS = {
  booked: "yellow-lt",
  reconfirmed: "purple-lt",
  confirmed: "blue-lt",
  printed: "red",
  played: "green-lt",
  finished: "red-lt",
  cancelled: "dark",
};

const TRANSPORT_COLORS = {
  OT: "red",
  PU: "green",
  P: "yellow",
  D: "blue",
  default: "dark",
};

const BookingCard = ({ booking, onClick }) => {
  // const { agents } = useAgent();
  // const { labels } = useLabel();

  // 🔹 Gunakan useMemo agar tidak menghitung ulang setiap render
  // const label = useMemo(
  //   () => labels.data.find((l) => l.id === booking.label_id) || null,
  //   [labels, booking.label_id]
  // );

  // const agent = useMemo(
  //   () => agents.data.find((a) => a.id === booking.agent_id) || null,
  //   [agents, booking.agent_id]
  // );

  return (
    // <div
    //   className={`card bg-${booking.status === "cancelled" ? "muted" : "light"}
    //   text-dark card-body px-3 py-2 cursor-pointer h-100 booking-card`}
    //   onClick={() => onClick(booking)}
    //   style={{
    //     borderLeft: `16px solid ${agent?.color || "light"}`,
    //     // minHeight: "110px", // ⬅️ Semua kartu punya tinggi minimal sama
    //     // display: "flex",
    //     // flexDirection: "column",
    //     // justifyContent: "space-between",
    //   }}
    // >
    <div
      className={`card ${
        booking.status === "cancelled" || booking.meta?.moved_to
          ? "bg-muted"
          : "bg-light"
      } text-dark card-body px-3 py-2 cursor-pointer h-100 booking-card`}
      onClick={() => onClick(booking)}
      style={{
        // borderLeft: `16px solid ${agent?.color || "light"}`,
        borderLeft: `16px solid ${booking?.agent?.color || "light"}`,
      }}
      title="Warna Agent"
    >
      {/* 🚗 Transport Badge */}
      <div
        className={`ribbon bg-${
          TRANSPORT_COLORS[booking.guest_transport] || TRANSPORT_COLORS.default
        }`}
        title="Transport"
        style={{
          height: "14px",
          lineHeight: "14px", // Pastikan teks di tengah
          fontSize: "10px",
          opacity: 0.8,
        }}
      >
        <b>{booking.guest_transport}</b>
      </div>

      {/* 📌 Status Booking */}
      {/* <span
        className={`badge bg-${
          STATUS_COLORS[booking.status] || "dark"
        } text-uppercase`}
        title="Status Booking"
        style={{
          minHeight: "22px",
          lineHeight: "22px",
          fontSize: "12px",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <b>{booking.status}</b>
      </span> */}
      {/* 📌 Status Booking */}
      <span
        className={`badge bg-${
          STATUS_COLORS[booking.status] || "dark"
        } text-uppercase ${booking.status === "printed" ? "text-white" : ""}`}
        title="Status Booking"
        style={{
          minHeight: "22px",
          lineHeight: "22px",
          fontSize: "12px",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <b>{booking.status}</b>
      </span>

      {/* 🏷 Booking ID */}
      <div
        className="h3 mb-1 fs-4"
        title="Kode Booking"
        style={{ fontSize: "18px", fontWeight: "bold" }}
      >
        {booking.code}
      </div>

      {/* 👤 Guest Info */}
      <div className="d-flex align-items-center gap-1">
        <IconComponent icon="person" title="Person" value={booking.guest_pax} />
        <span
          title={booking.guest_name}
          className="fs-4 text-truncate"
          style={{
            fontSize: "14px",
            lineHeight: "22px",
            maxWidth: "80px",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {booking?.guest_name?.length > 15
            ? booking.guest_name.substring(0, 10) + "..."
            : booking.guest_name}
        </span>
      </div>

      {/* 📍 Capacity & Agent */}
      <div className="d-flex align-items-center gap-2 mb-1">
        <IconComponent
          icon="bike"
          title="Bike"
          value={booking.qty_product_activities}
        />
        <IconComponent
          icon="agent"
          title="Agent Name"
          // value={agent?.name || "Unknown Agent"}
          value={booking?.agent?.name || "Unknown Agent"}
        />
      </div>

      {/* Hotel */}
      <div className="d-flex align-items-center gap-2 mb-1">
        <IconComponent
          icon="hotel"
          title="Hotel"
          value={
            booking?.customer?.nationality ||
            booking.guest_nationality ||
            "Unknown Hotel"
          }
        />
      </div>

      {/* 🏷 Label */}
      {/* {label && (
        <span
          className="badge fs-6"
          style={{
            backgroundColor: label.color || "#ccc",
            color: "#fff",
            height: "22px",
            lineHeight: "22px",
            fontSize: "14px",
            display: "inline-flex",
            alignItems: "center",
            padding: "2px 8px",
          }}
          title="Status Booking"
        >
          <b>{label.name}</b>
        </span>
      )} */}

      {/* 🏷️ Label */}
      {/* {booking.label_id && (
        <span
          className="badge fs-6"
          style={{
            backgroundColor: booking.label?.color || "#ccc",
            color: "#fff",
            height: "22px",
            lineHeight: "22px",
            fontSize: "14px",
            display: "inline-flex",
            alignItems: "center",
            padding: "2px 8px",
          }}
          title="Label"
        >
          <b>{booking.label?.name}</b>
        </span>
      )} */}

      {/* Labels */}
      {booking.labels?.map((label) => (
        <span
          key={label.id}
          className="badge fs-6 text-uppercase"
          style={{
            backgroundColor: label.color || "#ccc",
            // color: "#fff",
            color: getContrastColor(label.color || "#ccc"),
            height: "22px",
            lineHeight: "22px",
            fontSize: "14px",
            display: "inline-flex",
            alignItems: "center",
            padding: "2px 8px",
          }}
          title="Label"
        >
          <b>{label.name}</b>
        </span>
      ))}

      {/* 🔄 Moved To Info (Jika Ada) */}
      {booking.meta?.moved_to && (
        <div
          className="d-flex flex-wrap align-items-center gap-2 mt-2"
          style={{ wordBreak: "break-word" }} // Pastikan teks bisa turun ke baris baru
        >
          {/* <span className="badge bg-warning text-dark">Moved to</span> */}
          <span className="badge bg-warning text-dark fs-6 fw-bold text-wrap">
            Moved to: {booking.meta.moved_to.code} on{" "}
            {booking.meta.moved_to.reservation_date}
          </span>
        </div>
      )}
    </div>
  );
};

export default BookingCard;

const IconComponent = ({ icon, title, value }) => {
  const icons = {
    person: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="icon"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
        />
      </svg>
    ),
    bike: (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        height="1em"
        width="1em"
        className="icon"
      >
        <path d="M20 11c-.2 0-.4 0-.5.1L17.4 9H20V6l-3.7 1.9L13.4 5H9v2h3.6l2 2H11l-4 2-2-2H0v2h4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4l2 2h3l3.5-6.1 1 1c-.9.7-1.5 1.9-1.5 3.1 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4M4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m16 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
      </svg>
    ),
    agent: (
      <svg
        viewBox="0 0 640 512"
        fill="currentColor"
        height="1em"
        width="1em"
        className="icon me-1"
      >
        <path d="M506.1 127.1c-17.97-20.17-61.46-61.65-122.7-71.1-22.5-3.354-45.39 3.606-63.41 18.21C302 60.47 279.1 53.42 256.5 56.86c-79.7 12.31-129.8 79.34-131.9 82.24-7.844 10.69-5.531 25.72 5.125 33.57a23.858 23.858 0 0014.19 4.657c7.406 0 14.69-3.375 19.38-9.782.406-.563 40.19-53.91 100.5-63.23 7.457-.961 14.98.67 21.56 4.483L227.2 168.2c-12.4 12.3-20.1 27.9-20.1 46.3 0 17.5 6.812 33.94 19.16 46.29 13.24 12.41 29.64 18.31 47.14 18.31s33.94-6.813 46.31-19.19l11.35-11.35 124.2 100.9c2.312 1.875 2.656 5.251.5 7.97l-27.69 35.75c-1.844 2.25-5.25 2.594-7.156 1.063l-22.22-18.69-26.19 27.75c-2.344 2.875-5.344 3.563-6.906 3.719-1.656.156-4.562.125-6.812-1.719l-32.41-27.66L310.7 392.3l-2.812 2.938c-5.844 7.157-14.09 11.66-23.28 12.6-9.469.813-18.25-1.75-24.5-6.782L170.3 319.8H96V128.3H0v255.6l64 .04c11.74 0 21.57-6.706 27.14-16.14h60.64l77.06 69.66C243.7 449.6 261.9 456 280.8 456z" />
      </svg>
    ),
    hotel: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-building-skyscraper"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 21l18 0" />
        <path d="M5 21v-14l8 -4v18" />
        <path d="M19 21v-10l-6 -4" />
        <path d="M9 9l0 .01" />
        <path d="M9 12l0 .01" />
        <path d="M9 15l0 .01" />
        <path d="M9 18l0 .01" />
      </svg>
    ),
  };

  return (
    <span title={title} className="d-flex align-items-center fs-6">
      {icons[icon]} <span className="ms-1 fs-6">{value}</span>
    </span>
  );
};
